'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[ERROR] Application error:', error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#040a22] text-white">
      <div className="text-center p-8">
        <h2 className="text-2xl font-bold mb-4">Что-то пошло не так</h2>
        <p className="text-white/70 mb-4">{error.message}</p>
        {error.digest && (
          <p className="text-white/50 text-sm mb-4">Error digest: {error.digest}</p>
        )}
        <button
          onClick={() => reset()}
          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg"
        >
          Попробовать снова
        </button>
      </div>
    </div>
  );
}
